import angular from 'angular';
import '../../components/tree';

const module = angular.module('whyline.modals.new-segment', [
    'whyline.components.tree',
]);


const SegmentModalController = ($scope, $uibModalInstance, segmentId) => {
    'ngInject';
    $scope.newSegment = true;
    $scope.segmentId = segmentId;
    $scope.cancel = () => {
        $uibModalInstance.close('cancel');
        $scope.$broadcast('cancel-modal');
      };

    $scope.save = () => {
        $scope.$broadcast('save-segment');
    };

};

module.exports = module.controller('SegmentModalController', SegmentModalController);